import { EVENT_MESSAGES } from './utils';

declare global {
  interface Window {
    ActiveXObject: any;
  }
}

export interface IOptions {
  hideFooter?: boolean;
  width?: string;
  height?: string;
  style?: string;
  containerId?: string;
}

const DEFAULT_MODAL_ID = 'iframe_modal_content';
const DEFAULT_IFRAME_ELEMENT_ID = 'iframe_content';
var isIE = window.ActiveXObject || 'ActiveXObject' in window;

const getBody = () => {
  return document.getElementsByTagName('body')[0];
};

const createElementFromString = (htmlString) => {
  const div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
};

class FormBridgeMaster {
  _isReady: boolean;
  _uid: string;
  _iframeElementId: string;

  // 关闭 iframe
  // 兼容ie
  static close() {
    const ele = document.getElementById('iframe_modal_content');

    if (isIE) {
      const bodyEle = getBody();

      bodyEle && bodyEle.removeChild(ele);
    } else {
      ele && ele.remove();
    }

  }

  constructor(options?: { key?: string }) {
    this._isReady = false;
    this._uid = options?.key || '';
    this._iframeElementId = `${DEFAULT_IFRAME_ELEMENT_ID}-${this._uid}`;

    function func({ data }) {
      const { msg, uid } = data;
      if (uid && this._uid !== uid) {
        return;
      }
      if (msg === EVENT_MESSAGES.CLOSE_DIALOG) {
        console.log('[master]: client is close...');
        FormBridgeMaster.close();
      }
    };
    window.addEventListener('message', func.bind(this), false);
  }

  onReady(callback?: any) {
    callback && callback();
    console.log('[master]: master is ready...');
    this._isReady = true;
  }

  // 再指定div下面打开一个iframe页面
  openSlot(url: string, options?: IOptions) {
    const _options = {
      ...{
        width: '100%',
        height: '100%',
        hideFooter: false,
        style: '',
      },
      ...options,
    };
    const iframe = `<iframe src="${url}" id="${this._iframeElementId}" key="${this._uid}" style=" display: block; ${_options.style}" width="${_options.width}" frameBorder="0" height="${_options.height}" >
    </iframe>`;

    // 如果页面上有这个container，且container下内容为空，则添加 iframe 到这个container下
    const iframeContainer = document.getElementById(_options.containerId);
    const iframeEle = document.getElementById(this._iframeElementId);
    if (iframeContainer && !iframeEle) {
      iframeContainer.appendChild(createElementFromString(iframe));
    }
  }

  openDialog(url: string, options?: IOptions) {
    const _options = {
      ...{
        width: '100%',
        height: '100%',
        hideFooter: false,
        style: '',
      },
      ...options,
    };

    const modal = `
    <div id="${DEFAULT_MODAL_ID}" >
      <style>${_options.hideFooter ? '.iframe_modal_footer{ display: none}' : ''}</style>
      <div style="position: fixed; top: 0; bottom: 0; left: 0; right: 0; background-color: #000; opacity: 0.75; z-index: 9999"></div>
      <div style="position: fixed; top: 0; left: 10px; bottom: 0; right: 10px;  z-index: 10000" id="url_div_container">
        <iframe src="${url}" id="${this._iframeElementId}" key="${
      this._uid
      }" style=" display: block; ${_options.style}" width="${
      _options.width
      }" frameBorder="0" height="${_options.height}" >
        </iframe>
        <div style="text-align: right; padding: 16px;" class="iframe_modal_footer">
          <button onclick="formBridgeMaster.close()" style="order-radius: 100px;
          padding: 0 16px;
          height: 36px;
          line-height: 34px;
          font-size: 14px;
          border-radius: 5px;
          border: none;
          color: #fff;
          background: #255bda;">确认</button>
        </div>
      </div>
    </div>
    `;

    const iframeModalContent = document.getElementById(DEFAULT_MODAL_ID);
    if (!iframeModalContent) {
      const bodyEle = getBody();
      bodyEle && bodyEle.appendChild(createElementFromString(modal));
    }
  }

  // 打开 iframe 弹窗
  open(url: string, options?: IOptions) {
    return this.openDialog(url, options);
  }

  onClientReady(callback?: any) {
    function func({ data }) {
      const { msg, uid } = data;
      if (uid && this._uid !== uid) {
        return;
      }
      if (msg === EVENT_MESSAGES.CLIENT_READY) {
        window.removeEventListener('message', func);
        console.log('[master]: client is ready...');
        callback && callback(data);
      }
    };

    window.addEventListener('message', func.bind(this), false);
  }

  // 接收数据
  onReceiveData(callback?: any) {
    function func({ data }) {
      const { msg, uid } = data;
      if (uid && this._uid !== uid) {
        return;
      }
      if (msg === EVENT_MESSAGES.CLIENT_POST_DATA) {
        console.log('[master]: 接收来自表单数据', data.data);
        callback && callback(data.data);
      }
    };
    window.addEventListener('message', func.bind(this), false);
  }

  // 提交数据
  postData(data?: any) {
    const iframeEle: any = document.getElementById(this._iframeElementId);
    console.log('[master]: 向表单发送数据', data);
    iframeEle &&
      iframeEle.contentWindow &&
      iframeEle.contentWindow.postMessage({ uid: this._uid, ...data }, '*');
  }
}

export default FormBridgeMaster;
